import React from 'react';
import { makeStyles } from '@material-ui/styles';
import LogoBottom from '../../../../../../Assets/LOGO BOTTOM.png';

const useStyle = makeStyles(function() {
  return {
    footer: {
      position: 'relative',
      background: '#006650',
      padding: '18px 40px 18px 80px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      flexWrap: 'wrap',
      gap: '8px',
    },
    ribbon: {
      position: 'absolute',
      left: '16px',
      bottom: '0',
      width: '44px',
      height: 'auto',
      display: 'block',
      '@media (max-width: 768px)': {
        display: 'none',
      },
    },
    copyright: {
      fontFamily: 'Open Sans',
      fontSize: '13px',
      color: 'rgba(255,255,255,0.75)',
      margin: '0',
    },
    powered: {
      fontFamily: 'Open Sans',
      fontSize: '13px',
      color: 'rgba(255,255,255,0.75)',
      margin: '0',
      '& span': {
        color: '#8dc63f',
        fontWeight: '600',
      },
    },
  };
});

function Footer() {
  const classes = useStyle();
  const year = new Date().getFullYear();

  return (
    <footer className={classes.footer}>
      <img src={LogoBottom} alt="Old Mutual" className={classes.ribbon} />
      <p className={classes.copyright}>
        &copy; {year} Inclusivity Solutions. All rights reserved.
      </p>
      <p className={classes.powered}>
        Powered by <span>Inclusivity Solutions</span>
      </p>
    </footer>
  );
}

export default Footer;
